import React from 'react'
import ReactDOM from 'react-dom'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlangV2, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken, getMediaType, isRtl, isVoca } from 'src/helper/tool'
import langM from './lang'
import SVGA from 'svgaplayerweb'
import { apiGetCountDown } from 'src/store/activity/week'
import http from 'src/helper/http'
import { jumpToUser, toAppShow, getDeviceInfo } from 'src/helper/webviewFun'
import MediaModal from 'src/component/media-modal'
import dsBridge from 'dsbridge'
import { compareVersion } from 'src/helper/domain'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.min.css'
import TabWealth from './tab-wealth'
import TabCharm from './tab-charm'
import TabReward from './tab-reward'
import lang from './lang'
// import VConsole from 'src/helper/vconsole'

@inject('store')
@observer
export default class WeekStar extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
  }
  state = {
    rrShow: false, // 新的侠士
    lang: langM.en,
    language: 'en',
    selecCardItem: 0,
    inWeekIndex: 0,
    showMoldRoot: false,
    dayNum: 0,
    hourNum: 0,
    minNum: 0,
    secondNum: 0,
    rewardIndex: 0,
    rangTopImgArr: [
      '/img/activity/newWeeklyStar/ranking_one_icon.png',
      '/img/activity/newWeeklyStar/ranking_two_icon.png',
      '/img/activity/newWeeklyStar/ranking_three_icon.png'
    ],
    wealthReward: {},
    charmReward: {},
    lostRankingList: [],
    rankingList: [],
    weThisTopList: [], // 财富当前排名
    chThisTopList: [], // 魅力当前排名
    weLostTopList: [], // 财富上周排名
    chLostTopList: [], // 魅力上周排名
    weThisRankingList: [], // 财富当前周排名
    welostRankingList: [], // 财富上周排名
    chThisRankingList: [], // 魅力当前周排名
    chlostRankingList: [], // 魅力上周排名
    topList: [
      [
        {
          avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
          nickname: isVoca() ? 'Voca' : 'Yayya',
          score: 0
        },
        {
          avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
          nickname: isVoca() ? 'Voca' : 'Yayya',
          score: 0
        },
        {
          avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
          nickname: isVoca() ? 'Voca' : 'Yayya',
          score: 0
        }
      ]
    ],
    lostTopList: [
      [
        {
          avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
          nickname: isVoca() ? 'Voca' : 'Yayya',
          score: 0
        },
        {
          avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
          nickname: isVoca() ? 'Voca' : 'Yayya',
          score: 0
        },
        {
          avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
          nickname: isVoca() ? 'Voca' : 'Yayya',
          score: 0
        }
      ]
    ],
    showModlItem: 0,
    fasArr: [
      {
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        score: 0
      },
      {
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        score: 0
      },
      {
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        score: 0
      }
    ],
    chIndex: 0,
    weIndex: 0,
    giftList: [],
    giftLastList: [],
    showRankingList: [],
    showUrl: '',
    wewbase: '',
    weThisMyRank: {},
    weLastMyRank: {},
    chThisMyRank: {},
    chLastMyRank: {},
    myRankArr: [],
    compMyRank: {},
    showTabNo: false,
    mediaVisible: false,
    activeMedia: {},
    cardItemList: [],
    isShowMyRank: false,
    myRank: {},
    bannerList: {
      en: '/img/activity/newWeeklyStar/new_week_en.png',
      tr: '/img/activity/newWeeklyStar/new_week_tr.png',
      ar: '/img/activity/newWeeklyStar/new_week_ar.png'
    }
  }

  async componentWillMount() {
    const isProd = process.env.NODE_ENV === 'production'
    if (!isProd) {
      // new VConsole()
      console.log('this.props.location', this.props.location)
    }

    let { language } = this.props.location.query
    language = await getlangV2(language, langM)
    let a = (new Date().getTime() / 1000).toFixed(0)
    const currentlang = setlang(language, langM)
    const txtList = [currentlang.wealth, currentlang.charm, currentlang.reward]
    this.setState({
      lang: currentlang,
      language: language,
      selecCardItem: isRtl(language) ? 2 : 0,
      showTabNo: a > 1719158700 ? true : false,
      cardItemList: isRtl(language) ? txtList.reverse() : txtList
    })
    setDocumentTitle(this.state.lang.domTitle)
    let uid = await setUidToken(this.props.location.query)
    console.log('uid', uid)

    try {
      let connectionInfo = window.navigator.connection
      // console.log(connectionInfo.effectiveType, '-Internet-')
      // console.log(connectionInfo.downlink, '-Internet-')
    } catch (error) {
      // console.log(error)
    }
    this.RunOnStart(uid)
  }

  RunOnStart(uid) {
    // console.log(uid)
    apiGetCountDown().then((res) => {
      this.setState({ time: res.res })
      if (res.res > 0) {
        this.countDown(res.res)
      }
    })
    this.getRankingList()
    this.getWreward()
    this.getRankingLostList()
    this.getGiftList()
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    language = await getlangV2(language)
    this.$logEvent('weeklyStar_main_screen')
    this.initSwiper(language)
    if (isVoca()) {
      const favicon = document.querySelector('link[rel="icon"]')
      favicon.href = '/img/voca-home/favicon_ico.png'
    }
  }

  countDown = (times) => {
    var timer = null
    let { lang } = this.state
    timer = setInterval(
      function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          // daystr = day
          daystr = day + lang.days
        }
        //time: daystr + hour + ':' + minute + ':' + second
        this.setState({
          dayNum: day,
          hourNum: hour,
          minNum: minute,
          secondNum: second
        })
        times--
      }.bind(this),
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  handleSetReward = (e) => {
    this.setState({ rewardIndex: e })
  }

  handleSetCardItem = (e) => {
    let { weIndex, chIndex, language } = this.state
    let a = e == 0 ? weIndex : chIndex
    this.swiperInstance.slideTo(e)
    this.setState({ selecCardItem: e, inWeekIndex: a })
    // this.getMyRankInfo(e, a)
    // this.getRankListArr(e)
  }

  async getRankingList() {
    let { fasArr } = this.state
    let res = await http.post('/web/weekly/getrankbytype', { weekType: 0, rankType: 0 })
    if (res.code == 0) {
      let arr = res.res.list ? res.res.list.slice(0, 3) : fasArr
      if (arr.length < 3) {
        arr = [...arr, ...fasArr]
      }
      let arr2 = res.res.list ? res.res.list : []
      this.setState({
        topList: [arr],
        weThisTopList: arr,
        rankingList: [arr2],
        weThisRankingList: arr2,
        showRankingList: arr2,
        weThisMyRank: res.res.mine,
        myRank: res.res.mine, // 设置默认值
        isShowMyRank: res.res.mine && res.res.mine.avatarurl,
        compMyRank: res.res.mine
      })
    }
    this.getCharm()
  }

  async getRankingLostList() {
    let { fasArr } = this.state
    let res = await http.post('/web/weekly/getrankbytype', { weekType: 1, rankType: 0 }) //1上周
    if (res.code == 0) {
      let arr = res.res.list ? res.res.list.slice(0, 3) : fasArr
      let arr2 = res.res.list ? res.res.list : []
      if (arr.length < 3) {
        arr = [...arr, ...fasArr]
      }

      this.setState({
        lostTopList: [arr],
        weLostTopList: arr,
        lostRankingList: [arr2],
        weLostRankingList: arr2,
        weLastMyRank: res.res.mine
      })
    }
    this.getCharmList()
  }

  async getCharm() {
    let { rankingList, topList, fasArr } = this.state
    let res = await http.post('/web/weekly/getrankbytype', { weekType: 0, rankType: 1 })
    if (res.code == 0) {
      let arr = res.res.list ? res.res.list.slice(0, 3) : fasArr
      if (arr.length < 3) {
        arr = [...arr, ...fasArr]
      }
      let arr2 = res.res.list ? res.res.list : []
      this.setState({
        topList: [...topList, arr],
        rankingList: [...rankingList, arr2],
        chThisTopList: arr,
        chThisRankingList: arr2,
        chThisMyRank: res.res.mine
      })
    }
  }

  async getCharmList() {
    let { lostRankingList, lostTopList, fasArr } = this.state
    let res = await http.post('/web/weekly/getrankbytype', { weekType: 1, rankType: 1 })
    if (res.code == 0) {
      let arr = res.res.list ? res.res.list.slice(0, 3) : fasArr
      if (arr.length < 3) {
        arr = [...arr, ...fasArr]
      }
      let arr2 = res.res.list ? res.res.list : []
      this.setState({
        lostTopList: [...lostTopList, arr],
        lostRankingList: [...lostRankingList, arr2],
        chLostTopList: arr,
        chlostRankingList: arr2,
        chLastMyRank: res.res.mine
      })
    }
  }

  async getWreward() {
    let res = await http.post('/web/weekly/rewardlist', { rankType: 0 })
    if (res.code == 0) {
      this.setState({ wealthReward: res.res })
    }
    this.getCreward()
  }

  async getCreward() {
    let res = await http.post('/web/weekly/rewardlist', { rankType: 1 })
    if (res.code == 0) {
      this.setState({ charmReward: res.res })
    }
  }

  getTopkey(e, keys) {
    let { selecCardItem, topList, lostTopList, inWeekIndex, language } = this.state
    let str = ''
    let a = inWeekIndex == 0 ? topList : lostTopList
    str = a[selecCardItem] ? a[selecCardItem][e][keys] : ''
    return str
  }

  topJt(e) {
    let { selecCardItem, topList, lostTopList, inWeekIndex } = this.state
    let a = inWeekIndex == 0 ? topList : lostTopList
    let s = a[selecCardItem][e].uid
    jumpToUser(s)
  }

  getRankListArr(e) {
    let { selecCardItem, lostRankingList, rankingList, inWeekIndex, weIndex, chIndex } = this.state
    let str = [rankingList, lostRankingList]
    let c = e == 0 ? weIndex : chIndex
    let b = str[c][e]
    this.setState({ showRankingList: b })
  }

  getMyRankInfo = (e, a) => {
    let { selecCardItem, chIndex, weIndex, weLastMyRank, weThisMyRank, chLastMyRank, chThisMyRank, inWeekIndex } =
      this.state
    let arr = [
      [weThisMyRank, weLastMyRank],
      [chThisMyRank, chLastMyRank]
    ]
    let s = selecCardItem == 0 ? weIndex : chIndex
    let ar = arr[e][a]
    this.setState({ compMyRank: ar })
  }

  handleSetLastThis = async (e) => {
    let { weIndex, chIndex, selecCardItem } = this.state
    let a = selecCardItem == 0 ? e : weIndex
    let b = selecCardItem == 1 ? e : chIndex
    await this.setState({ inWeekIndex: e, weIndex: a, chIndex: b })
    this.getRankListArr(selecCardItem)
    this.getMyRankInfo(selecCardItem, e)
  }

  async getGiftList() {
    let res = await http.post('/web/weekly/giftlist', { weekType: 0 })
    if (res.code == 0) {
      this.setState({ giftList: res.res })
    }
    this.getGiftLastList()
  }

  async getGiftLastList() {
    let { language } = this.state
    let res = await http.post('/web/weekly/giftlist', { weekType: 1 })
    if (res.code == 0) {
      this.setState({ giftLastList: res.res })
    }
    let a = document.querySelector('.gift-item-root')
    let b = document.querySelector('.gift-item')
    // console.log(b.clientWidth,4564645646)
    let c = b.clientWidth * 0.86
    setTimeout(() => {
      a.scrollTo({
        [isRtl(language) ? 'right' : 'left']: c.toFixed(0),
        behavior: 'smooth'
      })
    }, 400)
  }

  getMyRandkIndex(e) {
    let str = ''
    if (e.rankIdx == 0 || !e.rankIdx) {
      str = '20+'
    } else if (e.rankIdx >= 20) {
      str = `${20}+`
    } else if (e.rankIdx <= 20) {
      str = e.rankIdx
    }
    return str
  }

  score(e) {
    if (e == '0.5') {
    }
    e = e * 1 || 0
    if (e > 1000000) {
      e = (parseInt(e / 100000) / 10).toFixed(1) + 'M'
    } else if (e >= 1000) {
      e = (parseInt(e / 100) / 10).toFixed(1) + 'K'
    }

    return e || `- -`
  }

  _hewname(e, op) {
    let { language } = this.state
    let reps = isRtl(language) ? 'rewardNameAr' : language == 'tr' ? 'rewardNameTr' : 'rewardName'
    return e[op] ? e[op][reps] : ''
  }

  _getRewNa(e) {
    let { language } = this.state
    let reps = isRtl(language) ? 'rewardNameAr' : language == 'tr' ? 'rewardNameTr' : 'rewardName'
    return e[reps]
  }

  handleShow(e) {
    if (!e.preview) return
    this.onSetActiveMedia(e)
    // let a = e.preview
    // let lses = e.preview.split('.')
    // this.setState({ showMoldRoot: true, showUrl: a, wewbase: lses[lses.length - 1], showModlItem: 1 })
    // setTimeout(() => {
    //   new SVGA.autoload(document.querySelector('#show-innew'))
    // }, 100)
  }

  // 设置播放对象
  onSetActiveMedia = async (media) => {
    const deviceInfo = await getDeviceInfo()
    if (dsBridge.hasNativeMethod('toAppShow') && compareVersion(deviceInfo.res.version || '', '5.3.0') === 1) {
      // console.log('原生播放')
      toAppShow({
        loopUrl: media.preview,
        loop: 1,
        loopType: getMediaType(media.show_type, media.preview)
      })
    } else {
      // console.log('h5播放')
      this.setState({
        activeMedia: {
          show_url: media.preview,
          vap_json: media.vapInfo
        },
        mediaVisible: true
      })
    }
  }

  // 关闭 MediaModal
  onCloseMediaModal = () => {
    this.setState({
      mediaVisible: false,
      activeMedia: {}
    })
  }

  initSwiper = (language) => {
    const currentLang = language || this.state.language
    this.swiperInstance = new Swiper(this.swiperRef.current, {
      autoplay: false,
      slidesPerView: 1,
      initialSlide: isRtl(currentLang) ? 2 : 0,
      autoHeight: true
    })

    this.swiperInstance.on('slideChange', (slide) => {
      const { activeIndex } = slide
      this.setState({ selecCardItem: activeIndex })
      let childType = 'this'
      // 选中魅力榜
      if (activeIndex === 1) {
        childType = window.sessionStorage.getItem('myRankCh') || 'this'
      } else {
        childType = window.sessionStorage.getItem('myRankWh') || 'this'
      }

      this.updateMyRank(childType, activeIndex)
    })
  }

  // 渲染财富榜
  renderWealth = () => {
    let {
      language,
      lang,
      rangTopImgArr,
      giftList,
      giftLastList,
      weThisTopList,
      weThisRankingList,
      weThisMyRank,
      weLostTopList,
      weLostRankingList,
      weLastMyRank,
      showTabNo,
      selecCardItem
    } = this.state

    return (
      <TabWealth
        language={language}
        lang={lang}
        rangTopImgArr={rangTopImgArr}
        giftList={giftList}
        giftLastList={giftLastList}
        thisTopList={weThisTopList}
        lostTopList={weLostTopList}
        thisRankingList={weThisRankingList}
        lostRankingList={weLostRankingList}
        thisMyRank={weThisMyRank}
        lostMyRank={weLastMyRank}
        showTabNo={showTabNo}
        selecCardItem={selecCardItem}
        onUpdateMyRank={this.updateMyRank}
        onNoSwiping={this.onNoSwiping}
      />
    )
  }

  // 渲染魅力榜
  renderCharm = () => {
    let {
      language,
      lang,
      giftList,
      giftLastList,
      showTabNo,
      chThisTopList,
      chThisRankingList,
      chThisMyRank,
      chLostTopList,
      chlostRankingList,
      chLastMyRank
    } = this.state

    return (
      <TabCharm
        language={language}
        lang={lang}
        giftList={giftList}
        giftLastList={giftLastList}
        showTabNo={showTabNo}
        thisTopList={chThisTopList}
        thisRankingList={chThisRankingList}
        thisMyRank={chThisMyRank}
        lostTopList={chLostTopList}
        lostRankingList={chlostRankingList}
        lastMyRank={chLastMyRank}
        onUpdateMyRank={this.updateMyRank}
        onNoSwiping={this.onNoSwiping}
      />
    )
  }

  // 渲染奖励
  renderReward = () => {
    let { language, lang, wealthReward, charmReward } = this.state

    return (
      <TabReward
        language={language}
        lang={lang}
        wealthReward={wealthReward}
        charmReward={charmReward}
        onSetActiveMedia={this.onSetActiveMedia}
      />
    )
  }

  // 更新我的排名
  updateMyRank = (childType, index) => {
    const { language, selecCardItem, weThisMyRank, weLastMyRank, chThisMyRank, chLastMyRank } = this.state
    const currentItemIndex = index >= 0 ? index : selecCardItem

    // 阿语并且选中奖励不显示 or 选中奖励不显示
    if ((isRtl(language) && currentItemIndex === 0) || (!isRtl(language) && currentItemIndex === 2)) {
      this.setState({
        isShowMyRank: false
      })
      return false
    }

    // 阿语且选中财富榜 or 选中财富榜
    if ((isRtl(language) && currentItemIndex === 2) || currentItemIndex === 0) {
      // 本周
      if (childType === 'this') {
        this.setState({
          isShowMyRank: true,
          myRank: weThisMyRank
        })
        window.sessionStorage.setItem('myRankWh', 'this')
      } else {
        this.setState({
          isShowMyRank: true,
          myRank: weLastMyRank
        })
        window.sessionStorage.setItem('myRankWh', 'last')
      }
    }

    // 选中魅力榜
    if (currentItemIndex === 1) {
      if (childType === 'this') {
        this.setState({
          isShowMyRank: true,
          myRank: chThisMyRank
        })
        window.sessionStorage.setItem('myRankCh', 'this')
      } else {
        this.setState({
          isShowMyRank: true,
          myRank: chLastMyRank
        })
        window.sessionStorage.setItem('myRankCh', 'last')
      }
    }
  }

  // 禁止滚动
  onNoSwiping = (value) => {
    this.swiperInstance.allowTouchMove = value
  }

  render() {
    let {
      language,
      lang,
      selecCardItem,
      inWeekIndex,
      showMoldRoot,
      wewbase,
      showUrl,
      dayNum,
      hourNum,
      minNum,
      secondNum,
      rewardIndex,
      giftList,
      giftLastList,
      showRankingList,
      showModlItem,
      wealthReward,
      charmReward,
      compMyRank,
      showTabNo,
      mediaVisible,
      activeMedia,
      cardItemList,
      isShowMyRank,
      myRank,
      bannerList,
      newWeekImg,
      rulesImg
    } = this.state
    return (
      <div className={`new-week-page ${isRtl(language) ? 'arlang' : ''}`}>
        <div className="new-weekbanner" style={{ backgroundImage: `url(${bannerList[language] || bannerList['en']})` }}>
          <div
            style={{ justifyContent: `${isRtl(language) ? '' : 'flex-end'}` }}
            className={`rules_btn ${language}`}
            onClick={() => this.setState({ showMoldRoot: true })}
          >
            <p>{lang.rules}</p>
          </div>
          <div className="time-root">
            <div className="date-item">
              <div className="time-num">{dayNum}</div>
              <div className="time-text">{lang.days}</div>
            </div>
            <div className="date-item">
              <div className="time-num">{hourNum}</div>
              <div className="time-text">{lang.hours}</div>
            </div>
            <div className="date-item">
              <div className="time-num">{minNum}</div>
              <div className="time-text">{lang.minutes}</div>
            </div>
            <div className="date-item">
              <div className="time-num">{secondNum}</div>
              <div className="time-text">{lang.seconds}</div>
            </div>
          </div>
        </div>
        <div className="new-week-body">
          <div className="select-show-card" style={{ direction: isRtl(language) ? 'ltr' : 'inherit' }}>
            {cardItemList.length > 0 &&
              cardItemList.map((txt, index) => (
                <div
                  onClick={() => this.handleSetCardItem(index)}
                  className={`${selecCardItem === index ? 'select-item' : 'no-select-card'}`}
                  key={index}
                >
                  {txt}
                </div>
              ))}
          </div>
          <div
            className="swiper-container"
            ref={this.swiperRef}
            style={{ direction: isRtl(language) ? 'ltr' : 'inherit' }}
          >
            <div className="swiper-wrapper">
              {!isRtl(language) &&
                [this.renderWealth(), this.renderCharm(), this.renderReward()].map((item, index) => (
                  <div className="swiper-slide" key={index}>
                    {item}
                  </div>
                ))}
              {isRtl(language) &&
                [this.renderWealth(), this.renderCharm(), this.renderReward()].reverse().map((item, index) => (
                  <div className="swiper-slide" key={index}>
                    {item}
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="activity-tip">
          <div>{lang.weekly_star_button_introduction_1}</div>
          <div>{lang.weekly_star_button_introduction_2}</div>
        </div>
        {isShowMyRank &&
          myRank.avatarurl &&
          ReactDOM.createPortal(
            <div className="rank-fixed-card">
              <div className="rank-fixed-placeholder"></div>
              <div className="rank-yourself">
                <div className="rank-yourself-left">
                  <div className="rank-yourself-num">{this.getMyRandkIndex(myRank)}</div>
                  <img className="your-atv" src={myRank.avatarurl} onClick={() => jumpToUser(myRank.uid)}></img>
                  <div className="your-name">{myRank.nickname}</div>
                </div>
                <div className="rank-yourself-right">
                  <img className="gold-icon" src="/img/activity/newWeeklyStar/gold_icon_img.png"></img>
                  <div className="gold-num">{this.score(myRank.score)}</div>
                </div>
              </div>
            </div>,
            document.querySelector('.new-week-page')
          )}
        {showMoldRoot && (
          <div className="show-rules-modle" onClick={() => this.setState({ showMoldRoot: false, showModlItem: 0 })}>
            <div>
              {showModlItem == 0 && (
                <div className="rules-root" onClick={(e) => e.stopPropagation()}>
                  <div className="text-rules">{lang.rules}</div>
                  <div className="rules-connten-text">
                    <div>{lang.rules_introduction_1}</div>
                    <div>{lang.rules_introduction_2}</div>
                    <div>{lang.rules_introduction_3}</div>
                  </div>
                </div>
              )}
              {showModlItem == 1 && (
                <div className="show-gift-show" onClick={(e) => e.stopPropagation()}>
                  {wewbase == 'svga' && (
                    <div
                      className="show-innew"
                      id="show-innew"
                      src={showUrl}
                      onClick={(e) => e.stopPropagation()}
                    ></div>
                  )}
                  {wewbase == 'mp4' && (
                    <video
                      className="show-innew"
                      autoPlay
                      loop
                      muted
                      play="true"
                      playsInline={true}
                      webkit-playsinline="true"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <source src={showUrl} type="video/mp4" />
                    </video>
                  )}
                </div>
              )}
              <img
                className="cloes-img-fn"
                style={{ [isRtl(language) ? 'marginRight' : 'marginLeft']: '2.8rem' }}
                onClick={() => this.setState({ showMoldRoot: false })}
                src="/img/activity/newWeeklyStar/close_root.png"
              ></img>
            </div>
          </div>
        )}
        <MediaModal visible={mediaVisible} media={activeMedia} onClose={this.onCloseMediaModal} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/newWeeklyStar/index.js